module.exports = __webpack_public_path__ + "static/media/5.2958ee4f.png";